import * as ReviewFormsAPI from '../api/ReviewForms.api';
import WpToastManager from 'Wpds/components/toast/WpToastManager';

import ReviewFormsSchema from 'Shared/utils/normalizeJSON/schemas/ReviewForms.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import ReviewFormsConstants from '../constants/ReviewForms.constants';

import { showNotificationError } from 'Shared/helpers';

const fetchReviewFormsSuccess = payload => ({
  type: ReviewFormsConstants.Actions.FETCH_REVIEW_FORMS_SUCCESS,
  payload,
});

const submitReviewFormSuccess = payload => ({
  type: ReviewFormsConstants.Actions.SUBMIT_REVIEW_FORM_SUCCESS,
  payload,
});

const unsubmitReviewFormSuccess = payload => ({
  type: ReviewFormsConstants.Actions.UNSUBMIT_REVIEW_FORM_SUCCESS,
  payload,
});

const createReviewFormSuccess = payload => ({
  type: ReviewFormsConstants.Actions.CREATE_REVIEW_FORMS_SUCCESS,
  payload,
});

const deleteReviewFormSuccess = payload => ({
  type: ReviewFormsConstants.Actions.DELETE_REVIEW_FORMS_SUCCESS,
  payload,
});

const updateReviewFormCompilerSuccess = payload => ({
  type: ReviewFormsConstants.Actions.UPDATE_REVIEW_FORM_COMPILER_SUCCESS,
  payload,
});

const reopenReviewFormSuccess = payload => ({
  type: ReviewFormsConstants.Actions.REOPEN_REVIEW_FORM_SUCCESS,
  payload,
});

export const reopenReviewForm = (formSlug: string) => dispatch => {
  return ReviewFormsAPI.reopenReviewForm(formSlug)
    .then(response => {
      dispatch(reopenReviewFormSuccess(normalizer(ReviewFormsSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const fetchReviewForm = formSlug => dispatch => {
  return ReviewFormsAPI.fetchReviewForm(formSlug)
    .then(response => {
      dispatch(fetchReviewFormsSuccess(normalizer(ReviewFormsSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const createReviewFormEditingSession = formSlug => dispatch => {
  return ReviewFormsAPI.createReviewFormEditingSession(formSlug)
    .then(response => {
      dispatch(fetchReviewFormsSuccess(normalizer(ReviewFormsSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
      return error.response;
    });
};

export const submitReviewForm = (formSlug, data) => dispatch => {
  return ReviewFormsAPI.submitReviewForm(formSlug, data)
    .then(response => {
      dispatch(submitReviewFormSuccess(normalizer(ReviewFormsSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const unsubmitReviewForm = formSlug => dispatch => {
  const data = {
    review_form: {
      unsubmit: true,
    },
  };

  return ReviewFormsAPI.unsubmitReviewForm(formSlug, data)
    .then(response => {
      dispatch(unsubmitReviewFormSuccess(normalizer(ReviewFormsSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const createReviewForm = data => dispatch => {
  return ReviewFormsAPI.createReviewForm(data)
    .then(response => {
      dispatch(createReviewFormSuccess(normalizer(ReviewFormsSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const deleteReviewForm = formSlug => dispatch => {
  return ReviewFormsAPI.deleteReviewForm(formSlug)
    .then(response => {
      dispatch(deleteReviewFormSuccess(formSlug));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const updateReviewFormCompiler = (formSlug, data) => dispatch => {
  return ReviewFormsAPI.updateReviewFormCompiler(formSlug, data)
    .then(response => {
      dispatch(updateReviewFormCompilerSuccess(normalizer(ReviewFormsSchema, response.data)));
      WpToastManager.success('Compiler updated');
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
